export default __webpack_public_path__ + "static/media/Ibbani.b7b55d8a.png";